import Image from "next/image";
import USPImage from '../../../public/assets/usp.webp'
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import PermPhoneMsgOutlinedIcon from '@mui/icons-material/PermPhoneMsgOutlined';
function USP()
{
    return <div id="USP" className="flex flex-col relative bottom-[326px] w-[100%] px-[19px] justify-center items-center">
        <div id="usp-image" className="w-fit rounded-[24px] custom-border-seeker mt-[20px]">
            <Image src={USPImage} width={300} height={312} alt="mobile_lokal" className="rounded-[24px]"/>
        </div>
        <div className="flex flex-col space-y-[16px] w-[300px] pt-[10px]">
        <div id="salary" className="p-[20px] rounded-[24px] font-noto-sans  custom-border-seeker custom-bg w-[100%] text-[24px] flex items-center gap-x-[8px] border-solid border-greyDisabledBackground50 font-semibold text-greyTitleBase900"> <CurrencyRupeeIcon sx={{width:"24px",height:"24px" ,fontWeight:700}} className="text-blueSecondary500"/> Best Salary</div>
        <div id="jobs" className="p-[20px] rounded-[24px] font-noto-sans  custom-border-seeker custom-bg text-[24px]  flex items-center gap-x-[8px] border-solid border-greyDisabledBackground font-semibold text-greyTitleBase900"><VerifiedUserOutlinedIcon sx={{width:"24px",height:"24px" ,fontWeight:700}} className="text-blueSecondary500"/> Verified Local jobs</div>
        <div id="talk" className="p-[20px] rounded-[24px] font-noto-sans  custom-border-seeker custom-bg text-[24px]  flex items-center gap-x-[8px] border-solid border-greyDisabledBackground font-semibold text-greyTitleBase900"><PermPhoneMsgOutlinedIcon sx={{width:"24px",height:"24px" ,fontWeight:700}} className="text-blueSecondary500"/> Talk Directly to HR</div>

        </div>

    </div>

}

export default USP;